<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: 
-->
<template>
  <div class="lc-tabsNav__perTab">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LcTabNavPane',
  props: {
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {}
};
</script>